import { getTests } from "../../utils/ab_tests"

// this function should be called every time a new assignment is done during runtime
export const trackABTestsUpdate = (tests) => {
  if (typeof amplitude !== "undefined" && tests) {
    const identity = new amplitude.Identify()

    Object.keys(tests).forEach((testName) => {
      const value = tests[testName].value
      let name = testName

      if (tests[testName].version > 0) {
        name = `${name}:${tests[testName].version}`
      }
      if (value !== "none") {
        identity.set(name, value)
      }
    })

    amplitude.getInstance().identify(identity)
  }
}

// this function should called on page load
export const amplitudeABTestIdentify = async () => {
  if (typeof amplitude !== "undefined") {
    const tests = await getTests()

    trackABTestsUpdate(tests)
  }
}
